import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant1PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 1020 868",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.0767 433.025C215.272 380.397 377.221 345.059 522.461 397.597C595.014 423.866 661.402 473.858 694.506 543.552C727.7 613.469 721.624 706.081 666.316 763.579C603.368 829.028 501.553 791.992 487.167 704.071C478.188 649.12 504.68 593.276 543.146 553.112C581.656 512.905 631.156 485.384 679.317 457.552C732.659 426.725 785.51 394.648 834.564 357.344C878.659 323.793 921.056 283.853 939.417 231.583C963.453 163.229 941.83 87.4149 911.808 21.5186",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant1PathwayIllustration as default };
